import { Dialog, DialogContent } from '@mui/material';
import { useEffect, useState } from 'react';
import { PeopleService } from '../../../Component/Api/People/peopleService';
import { DataTable } from '../../../Component/Common/Components/DataTable/DataTable';
import { IFilter } from '../../../Component/Common/Components/DataTable/Filters';
import { ColumnSortOption } from '../../../Component/Model/Dto/ColumnSortOption';
import { PeopleDtos } from '../../../Component/Model/Dto/People';
import { ExportKeyValue } from '../../../Component/Model/Dto/Upload';
import { DataImportType } from '../../../Component/Model/Enum/BEE123Enums';
import { EntriesPerPage } from '../../../Component/Model/Table/Table';
import { emptyGuid } from '../../../Helpers/typescriptHelper';
import { CustomDialogTitle } from '../../Common/Custom/CustomDialogTitle';
import { ImportExportButtonsDialog } from '../../Common/ImportAndExport/ImportExportButtonsDialog';
import { PeopleSalariesModal } from './PeopleSalariesModal';
import { PeopleSalariesTableMapper } from './PeopleSalariesTable';
import config from '../../../config';
import { PeopleSalariesModal_Old } from './Old/PeopleSalariesModalOld';


const peopleSalariesFilters: Array<IFilter> = [
    {
        label: 'Gender:',
        values: [{ key: 'Male', val: 1 }, { key: 'Female', val: 2 }],
        type: 1, propname: 'genderIds',
        //action: () => { } - for individual filter change handles
    },
    {
        label: 'Race:',
        values: [{ key: 'African', val: 1 }, { key: 'Coloured', val: 2 }, { key: 'Indian', val: 3 }, { key: 'White', val: 4 }, { key: 'Non South African', val: 5 }],
        type: 1, propname: 'raceIds',

    },
    {
        label: 'Occupation Level:',
        values: [{ key: 'Executive Director', val: 1 },
        { key: 'Non Executive Director', val: 2 },
        { key: 'Executive Management', val: 3 },
        { key: 'Other Executive Management', val: 4 },
        { key: 'Senior Management', val: 5 },
        { key: 'Middle Management', val: 6 },
        { key: 'Junior Management', val: 7 },
        { key: 'Semi skilled', val: 8 },
        { key: 'Unskilled', val: 9 },
        { key: 'Unspecified', val: 10 }],
        type: 1, propname: 'occupationalLevelIds'

    },
    {
        label: 'Employee Type:',
        values: [
            { key: 'Employed By Other', val: 2 },
            { key: 'Employee', val: 1 },
            { key: 'Employee Previously Unemployed', val: 4 },
            { key: 'Unemployed', val: 3 }],
        type: 1, propname: 'employeeTypeIds'
    },
    {
        label: 'Disabled:',
        values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
        type: 1, propname: 'disabledValues'

    },
    {
        label: 'Province:',
        values: [
            { key: 'Unspecified', val: 0 },
            { key: 'National (NAT)', val: 1 },
            { key: 'Eastern Cape (EC)', val: 2 },
            { key: 'Free State (FS)', val: 3 },
            { key: 'Gauteng (GP)', val: 4 },
            { key: 'KwaZulu-Natal (KZN)', val: 5 },
            { key: 'Limpopo (LP)', val: 6 },
            { key: 'Mpumalanga (MP)', val: 7 },
            { key: 'North West (NW)', val: 8 },
            { key: 'Northern Cape (NC)', val: 9 },
            { key: 'Western Cape (WC)', val: 10 },
        ],
        type: 1, propname: 'provinceIds'
    },
    {
        label: 'Y.E.S. Employee:',
        values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
        type: 1, propname: 'isYesEmployeeValues'

    },
    {
        label: 'Y.E.S. Absorbed:',
        values: [{ key: 'Yes', val: true }, { key: 'No', val: false }],
        type: 1, propname: 'isYesAbsorbedValues'

    },
    {
        label: 'Start Period:',
        values: [],
        type: 3, propname: 'startDateRange',

    },
    {
        label: 'Termination Period:',
        values: [],
        type: 3, propname: 'endDateRange',

    }
];

const parameters: ExportKeyValue[] = [
    // {key:"ModuleType"}
];

export const PeopleSalariesDatatableWithActions = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [peopleSalariesModal, setPeopleSalariesModal] = useState<boolean>(false);
    const [personIdSalary, setPersonIdSalary] = useState<number>(0);
    const [peopleSalariesData, setPeopleSalariesData] = useState<PeopleDtos.PeopleSearchRow[]>([]);
    const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
    const [totalItemsCount, setTotalItemsCount] = useState<number>(0);

    const [pageNumber, setPageNumber] = useState<number>(1);
    const [searchValue, setSearchValue] = useState<string>("");
    const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({ defaultValue: 10 });
    const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
    const [filters, setFilters] = useState({});

    const peopleSalariesSearchRequest: PeopleDtos.PeopleSearchRequest = {
        pageNumber: pageNumber,
        pageSize: entriesPerPage.defaultValue!,
        searchValue: searchValue,
        registrationId: emptyGuid,
        scorecardIds: [],
        genderIds: [],
        raceIds: [],
        employeeTypeIds: [],
        disabledValues: [],
        occupationalLevelIds: [],
        provinceIds: [],
        isYesEmployeeValues: [],
        isYesAbsorbedValues: [],
        startDateFrom: undefined,
        startDateTo: undefined,
        endDateFrom: undefined,
        endDateTo: undefined,
        columnSortOptions: columnSortOptions
    }

    const entriesPerPageChanged = (entriesPerPage: number) => {
        setEntriesPerPage({ defaultValue: entriesPerPage });
        setPageNumber(1);
    }

    const pageNumberChanged = (pageNumber: number) => {
        setPageNumber(pageNumber);
    }

    const searchValueChanged = (value: string) => {
        setSearchValue(value);
        setPageNumber(1);
    }

    const columnSortingChanged = (sortOption: ColumnSortOption) => {
        setColumnSortOptions([sortOption]);
        setPageNumber(1);
    }

    const filtersChanged = (filterProps: any) => {
        //spread ranges into own props for request (startDateRange -> {startDateFrom, startDateTo})
        let startDateFrom = filterProps['startDateRange']?.start;
        let startDateTo = filterProps['startDateRange']?.end;
        let endDateFrom = filterProps['endDateRange']?.start;
        let endDateTo = filterProps['endDateRange']?.end;
        setFilters({ ...filterProps, startDateFrom, startDateTo, endDateFrom, endDateTo });
    }

    const onEditPeopleSalariesRow = (id: number) => {
        setPersonIdSalary(id);
        setPeopleSalariesModal(true);
    }

    const fetchData = async () => {
        setIsLoading(true);
        try {
            let request = { ...peopleSalariesSearchRequest, ...filters };
            let resp = await PeopleService.SearchPeople(request);
            if (resp.data) {
                setPeopleSalariesData(resp.data.results);
                setFilteredItemsCount(resp.data.filteredItemsCount);
                setTotalItemsCount(resp.data.totalItemsCount);
            }
        } catch (error) {
            console.log(error);
            setFilteredItemsCount(0);
            setTotalItemsCount(0);
        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [entriesPerPage, pageNumber, searchValue, columnSortOptions, filters]);

    const peopleSalariesTableData = PeopleSalariesTableMapper(peopleSalariesData, onEditPeopleSalariesRow);

    return (
        <>
            <DataTable
                key={totalItemsCount}
                table={peopleSalariesTableData}
                filters={peopleSalariesFilters}
                canSearch
                entriesPerPage={entriesPerPage}
                pageNumber={pageNumber}
                filteredItemsCount={filteredItemsCount}
                totalItemsCount={totalItemsCount}
                entriesPerPageChanged={entriesPerPageChanged}
                pageNumberChanged={pageNumberChanged}
                searchValueChanged={searchValueChanged}
                isLoading={isLoading}
                filtersChanged={filtersChanged}
                manualSorting={true}
                columnSortingChanged={columnSortingChanged}
            >
            </DataTable>
            <Dialog open={peopleSalariesModal} onClose={() => { setPeopleSalariesModal(false) }} aria-labelledby="form-dialog-title" maxWidth='lg' disableEnforceFocus>
                <CustomDialogTitle id="customized-dialog-title" onClose={() => setPeopleSalariesModal(false)}>
                    {'Salaries'}
                </CustomDialogTitle>
                <DialogContent>
                    {config.enable_employment_equity_salary === 'true' ?
                        <PeopleSalariesModal id={personIdSalary} />
                        :
                        <PeopleSalariesModal_Old id={personIdSalary} />
                    }
                </DialogContent>
            </Dialog>

            <ImportExportButtonsDialog
                uploadType={DataImportType[DataImportType.Salary]}
                controlsEnabled={true}
                showHelpfileDownload={true}
                importBus={true}
                coreExportEnabled={true}
                coreImportEnabled={true}
                type={"Salary"}
                typeId={DataImportType.Salary}
                parameters={parameters}
                reloadTable={fetchData}
                showYearToAdd={true}
                showAdditionalParamsModal={true} />
        </>
    );
}